import { CardTooltip } from "./CardTooltip";

interface CardMentionSpanProps {
  cardId: string;
  cardMap: Map<string, Scryfall.Card>;
}

/**
 * Renders a card reference from the chatbot's output.
 * Shows the card name with a styled background.
 * On hover, shows the card image tooltip.
 */
export function CardMentionSpan({ cardId, cardMap }: CardMentionSpanProps) {
  const card = cardMap.get(cardId);

  if (!card) {
    // Card not in our map — render plain text
    return <span>@{"{" + cardId + "}"}</span>;
  }

  return (
    <CardTooltip card={card}>
      <span className="inline-flex items-center px-1.5 py-0.5 text-xs font-medium rounded bg-secondary text-secondary-foreground border border-border cursor-pointer hover:bg-accent transition-colors">
        {card.name}
      </span>
    </CardTooltip>
  );
}
